export const SoarRisingDescriptionBody = ({ bod }) => {
  return (
    <div className="description-section-two">
      CMS website and integrated CRM solutions for SOARising.
    </div>
  );
};
